export const HOME = "/";
export const SCAN = "/scan";
export const ARTWORK = "/artwork";
export const EXHIBITION = "/exhibition";
export const STORY = "/story";
export const BOOKMARK_EMAIL = "/email/bookmark";
export const STORY_EMAIL = "/email/story";
